import {getDateNYC, isAfterFourPM, zeroPadding} from "@insticator/insticator-ui";
import {date} from "@storybook/addon-knobs";

export const daysPreviously = (days) => 1000 * 60 * 60 * 24 * days;

export const datetoAPIString = (date) => {
    return `${date.getFullYear()}-${zeroPadding((date.getMonth() + 1), 2)}-${zeroPadding(date.getDate(), 2)}`
};
export const APIStringtoDate = (dateString) => {
    const newDate = new Date(dateString.substring(0,4), dateString.substring(5,7)-1, dateString.substring(8,10));
    return newDate;
};

export const getFirstDateOfWeek = (week, year) => {
    const target = new Date(year, 0, 1 + (week - 1) * 7);
    const dow = target.getDay();
    const ISOweekStart = target;
    if (dow <= 4)
        ISOweekStart.setDate(target.getDate() - target.getDay());
    else
        ISOweekStart.setDate(target.getDate() + 7 - target.getDay());
    return ISOweekStart;
}

export const getEasternTimeZone = () => {
    const now = new Date();

    // Get the timezone name using the Intl.DateTimeFormat object
    const options = { timeZone: 'America/New_York', timeZoneName: 'short' };
    const timeZone = new Intl.DateTimeFormat('en-US', options).formatToParts(now);

    // Extract the time zone part
    const timeZoneName = timeZone.find(part => part.type === 'timeZoneName').value;

    // Return whether it's EDT or EST
    return timeZoneName
}

export const getEasternTimeDiff = () => {
    return getEasternTimeZone() === 'EST' ? 5 : 4
}

export const convertESTtoUTC = (ESTDateTimeString) => {
    if(!ESTDateTimeString) return null
    // Create a Date object from the EST time
    const date = new Date(ESTDateTimeString);

    // Convert to UTC
    const utcTime = date.toISOString();

    return utcTime

}

export const convertUTCToEST = (UTCDateTimeString) => {
    if(!UTCDateTimeString) return null

    // Parse the UTC datetime string to a Date object
    const utcDate = new Date(UTCDateTimeString);

    // Define options to format the date in the Eastern Time Zone
    const options = {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3,
        hour12: false,
    };

    // Format the UTC date in Eastern Time (handles both EST and EDT)
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(utcDate);

    const timeDiff = getEasternTimeZone() === 'EST' ? 5 : 4

    // Build the formatted datetime string
    const easternDateTime = `${parts[4].value}-${parts[0].value}-${parts[2].value}T${parts[6].value}:${parts[8].value}:${parts[10].value}.${parts[12].value || '000'}-0${timeDiff}:00`;

    return easternDateTime;
}

export const getStartAndEndDatesOfWeek = (week, year, formatted = true) => {
    const startDate = getFirstDateOfWeek(week, year);
    const endDate = getFirstDateOfWeek(week, year);
    endDate.setDate(endDate.getDate() + 6);
    if (formatted) return ({
        startDate: datetoAPIString(startDate),
        endDate: datetoAPIString(endDate)
    })
    else return ({startDate, endDate});
}

export const dateToArray = (date) => {
    return [
        date.getFullYear(),
        date.getMonth() + 1, // Month is 0-based, so add 1
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ];
};

export const convertTimestampsToDate = (dateArray) => {
    const [year, month, day, hour, minute, second] = dateArray;
    return new Date(year, month - 1, day, hour, minute, second);
};

export const checkDaysOfDifference = (startDate, endDate , daysDifference) => {
    const start = convertTimestampsToDate(startDate);
    const end = convertTimestampsToDate(endDate);
    const millisecondsPerDay = 1000 * 60 * 60 * 24;

    const difference = (end - start) / millisecondsPerDay;

    return difference <= daysDifference;

}

export const getDayOfTheWeek = (date) => {
    const newDate = new Date(date);
    const options = { weekday: 'long' };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(newDate);
}

export const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const dateStringToDateWithCurrentTime = (dateString) =>{
    const [year, month, day] = dateString.split('-').map(Number);
    const now = getRevenueAvailableDate();
    return new Date(year, month - 1, day, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
}

export const getRevenueAvailableDate = () => new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)));